// extracted by mini-css-extract-plugin
export default {"Paper":"Paper_Paper__0S+ef","LightPaper":"Paper_LightPaper__Y2rdb","DarkPaper":"Paper_DarkPaper__mkVoH"};